import { Tools } from "../utilities/Tools";

/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

class ModalDialog {
  constructor(toggle, settings = {}) {
    this.toggle = toggle;
    this.settings = Object.assign(
      {
        modalMountSelector: "body",
        modalId: "modal",
        modalTitle: "",
        modalScrollingLongContent: false, // boolean
        modalFullscreen: "", // modal-fullscreen (Always), modal-fullscreen-sm-down (Below 576px), modal-fullscreen-md-down (Below 768px), modal-fullscreen-lg-down (Below 992px), modal-fullscreen-xl-down (Below 1200px), modal-fullscreen-xxl-down
        modalSize: "", // modal-sm (Small 300px), '' (Default 500px), modal-lg (Large 800px), modal-xl (Extra large 1140px), modal-xl (Extra extra large 1780px)
        modalVerticallyCentered: false, // boolean
        modalCloseButton: {
          visible: false,
          text: "Zamknij",
        },
        modalConfirmButton: {
          visible: false,
          text: "Zastosuj",
        },
      },
      Tools.parseStringValuesInObjectLiteral(
        (() => {
          if (toggle) {
            const datasetObject = Object.assign({}, toggle.dataset);

            delete datasetObject.toggle;
            return datasetObject;
          } else {
            return {};
          }
        })()
      ),
      Tools.parseStringValuesInObjectLiteral(settings)
    );
    this.modal = undefined;
    this._showFunction = undefined;
    this._shownFunction = undefined;
    this._hideFunction = undefined;
    this._hiddenFunction = undefined;
    this._closeFunction = undefined;
    this._confirmFunction = undefined;

    // Inicjalizacja
    this.init();
  }

  get showFunction() {
    return this._showFunction;
  }

  set showFunction(value) {
    this._showFunction = value;
  }

  get shownFunction() {
    return this._shownFunction;
  }

  set shownFunction(value) {
    this._shownFunction = value;
  }

  get hideFunction() {
    return this._hideFunction;
  }

  set hideFunction(value) {
    this._hideFunction = value;
  }

  get hiddenFunction() {
    return this._hiddenFunction;
  }

  set hiddenFunction(value) {
    this._hiddenFunction = value;
  }

  get closeFunction() {
    return this._closeFunction;
  }

  set closeFunction(value) {
    this._closeFunction = value;
  }

  get confirmFunction() {
    return this._confirmFunction;
  }

  set confirmFunction(value) {
    this._confirmFunction = value;
  }

  events() {
    if (this.toggle) {
      this.toggle.addEventListener("click", (event) => {
        event.preventDefault();

        this.render();
      });
    }
  }

  eventsClose() {
    const _this = this;

    if (this.settings.modalCloseButton.visible) {
      document
        .getElementById(this.settings.modalId)
        .querySelector('.modal-footer [data-button="close"]')
        .addEventListener("click", (event) => {
          if (_this.closeFunction) {
            _this.closeFunction();
          }
        });
    }
  }

  eventsConfirm() {
    const _this = this;

    if (this.settings.modalConfirmButton.visible) {
      document
        .getElementById(this.settings.modalId)
        .querySelector('.modal-footer [data-button="confirm"]')
        .addEventListener("click", (event) => {
          if (_this.confirmFunction) {
            _this.confirmFunction();
          }

          //
          _this.modal.hide();
        });
    }
  }

  eventsInstance() {
    const _this = this;

    // Show
    document.getElementById(this.settings.modalId).addEventListener("show.bs.modal", function (event) {
      if (_this._showFunction) {
        _this._showFunction();
      }
    });

    // Shown
    document.getElementById(this.settings.modalId).addEventListener("shown.bs.modal", function (event) {
      if (_this._shownFunction) {
        _this._shownFunction();
      }
    });

    // Hide
    document.getElementById(this.settings.modalId).addEventListener("hide.bs.modal", function (event) {
      if (_this._hideFunction) {
        _this._hideFunction();
      }
    });

    // Hidden
    document.getElementById(this.settings.modalId).addEventListener("hidden.bs.modal", function (event) {
      if (_this._hiddenFunction) {
        _this._hiddenFunction();
      }

      //
      _this.modal.dispose();
      document.getElementById(_this.settings.modalId).remove();
    });
  }

  instance() {
    this.modal = new bootstrap.Modal(document.getElementById(this.settings.modalId), {
      backdrop: true,
      keyboard: true,
      focus: true,
    });

    //
    this.eventsInstance();

    //
    this.modal.show();
  }

  render() {
    const _this = this;

    document.querySelector(this.settings.modalMountSelector).insertAdjacentHTML(
      "beforeend",
      `
            <div class="modal fade"
                 id="${this.settings.modalId}"
                 tabindex="-1"
                 aria-labelledby="${this.settings.modalId}Label"
                 aria-hidden="true">
                <div class="modal-dialog ${(function () {
                  return [
                    _this.settings.modalFullscreen,
                    _this.settings.modalScrollingLongContent ? "" : "modal-dialog-scrollable",
                    _this.settings.modalSize,
                    _this.settings.modalVerticallyCentered ? "modal-dialog-centered" : "",
                  ].join(" ");
                })()}">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="${this.settings.modalId}Label">${this.settings.modalTitle}</h5>
                            <button type="button"
                                    class="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                        </div>
                        <div class="modal-body"></div>
                        <div class="modal-footer">
                        ${(function ({ modalCloseButton, modalConfirmButton }) {
                          let html = ``;

                          if (modalCloseButton.visible) {
                            html += `<button type="button" class="btn btn-secondary" data-button="close" data-bs-dismiss="modal">${modalCloseButton.text}</button>`;
                          }

                          if (modalConfirmButton.visible) {
                            html += `<button type="button" class="btn btn-primary" data-button="confirm">${modalConfirmButton.text}</button>`;
                          }

                          return html;
                        })(this.settings)}
                        </div>
                    </div>
                </div>
            </div>
            `
    );

    this.eventsClose();
    this.eventsConfirm();

    //
    this.instance();
  }

  init() {
    this.events();
  }
}

export { ModalDialog };
